import initSameLinksHover from './utils/sameLinksHover';
import preventFocusOnClick from './utils/preventFocusOnClick';

import initHeader from './components/header';
import initIndexAnimations from './components/indexAnimations';
import initTournamentAnimations from './components/tournamentAnimations';
import initMobileNav from './components/mobile-nav';
import initGallery from './components/gallery';

document.addEventListener('DOMContentLoaded', () => {
  preventFocusOnClick();
  initSameLinksHover();

  initHeader();
  initIndexAnimations();
  initTournamentAnimations();
  initMobileNav();
  initGallery();

  document.body.classList.add('body--loaded');
});



// WEBPACK FOOTER //
// ./assets/scripts/index.js